import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-checkout-flow',
  templateUrl: './checkout-flow.component.html',
  styleUrls: ['./checkout-flow.component.scss']
})
export class CheckoutFlowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
